import Button from "@mui/material/Button";
const selected=(data)=>{
if(data)
return "green"

}
export const AllowanceColumnSearch = [
	{
		name: 'Payee First Name',
		//selector: row => row.payeeFirstName.toUpperCase(),
		selector: row =>(row && row.payeeFirstName && row.payeeFirstName.trim().toUpperCase()) || "-",
        sortable: true,
		center: true
	},
	{
		name: 'Payee Last Name',
		//selector: row => row.payeeLastName.toUpperCase(),
		selector: row =>(row && row.payeeLastName && row.payeeLastName.trim().toUpperCase()) || "-",
        sortable: true,
		center: true
	},
	{
		name: '',
		sortable:true,
		field:'action',	
		cell: row => 
				<Button sx={{color:{selected}, textTransform:'unset !important', width:"120px",margin:"10px"}} 
				variant="outlined" row={row} data-tag="allowRowEvents" 
				> Select </Button>
	},
];